import { Link } from "react-router-dom";
import { TICKER } from "../data/stories";

const TickerItems = ({ ariaHidden = false }) => (
  <div aria-hidden={ariaHidden} className="flex items-center shrink-0">
    {TICKER.map((item, i) => (
      <Link
        key={i}
        to={`/${item.id}`}
        data-testid={`ticker-item-${i + 1}`}
        className="flex items-center gap-3 pr-10 text-[13px] font-medium text-[var(--ink)] hover:text-[var(--accent)] transition-colors whitespace-nowrap"
      >
        <span className="w-1.5 h-1.5 rotate-45 bg-[#cf0a0a] shrink-0" />
        {item.text}
      </Link>
    ))}
  </div>
);

export const Ticker = () => (
  <div
    data-testid="breaking-ticker"
    className="ticker-wrap border-b border-[var(--line)] bg-[var(--bg)]"
  >
    <div className="flex items-stretch">
      <div className="shrink-0 z-10 bg-[#cf0a0a] text-white px-3 sm:px-4 flex items-center text-[10px] sm:text-[11px] font-extrabold uppercase tracking-[0.22em]">
        Breaking
      </div>
      <div className="flex-1 overflow-hidden relative">
        <div className="ticker-track flex items-center py-2.5 w-max pl-6 pr-6">
          <TickerItems />
          <TickerItems ariaHidden />
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-8 bg-gradient-to-r from-[var(--bg)] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-[var(--bg)] to-transparent" />
      </div>
    </div>
  </div>
);

export default Ticker;
